import type { CSSProperties } from "react";

export const operationalTheme = {
  surface: "var(--login-surface)",
  surfaceRaised: "color-mix(in srgb, var(--login-surface) 94%, #ffffff 6%)",
  page: "var(--login-bg)",
  text: "var(--login-text)",
  muted: "var(--login-muted)",
  border: "color-mix(in srgb, var(--login-border) 86%, transparent)",
  accent: "var(--login-accent)",
  warning: "#d97706",
  success: "#16a34a",
  error: "#ef4444",
  rowHover: "color-mix(in srgb, var(--login-accent) 5%, transparent)",
  focus: "0 0 0 3px color-mix(in srgb, var(--login-accent) 22%, transparent)",
} as const;

export const operationalStyles = {
  controlButton: {
    width: "2.25rem",
    height: "2.25rem",
    borderRadius: "0.45rem",
    border: `1px solid ${operationalTheme.border}`,
    background: operationalTheme.surface,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flex: "0 0 auto",
  } satisfies CSSProperties,
  label: {
    margin: 0,
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: "0.72rem",
    fontWeight: 700,
    letterSpacing: "0.08em",
    color: operationalTheme.muted,
  } satisfies CSSProperties,
};
